import React from 'react';
import StatRow from './StatRow';
import Card from './Card';
import TiltTint from './TiltTint';
import DayMeter from './DayMeter';
import { useI18n } from '../i18n';

function ExitCard({ detail }) {
  const { card, direction, fromX, aesthetic } = detail;
  return (
    <div
      className={
        'card-exit-wrap card-exit-wrap--' + (direction === 'left' ? 'left' : 'right')
      }
    >
      <Card card={card} drag={{ x: fromX, dragging: false }} aesthetic={aesthetic} frozen />
    </div>
  );
}

export default function PlayScreen({
  stats, accent, pulse, drag, deck, currentCard,
  onPointerDown, onChoice, exiting, exitDetail, aesthetic, day, dayStyle,
}) {
  const { t, tc } = useI18n();
  const text = currentCard ? tc(currentCard.id) : {};
  const leftLabel = text.left || currentCard?.left.label;
  const rightLabel = text.right || currentCard?.right.label;

  return (
    <div className="play">
      <div className="play__top">
        <StatRow stats={stats} accent={accent} pulse={pulse} />
      </div>
      <div className="play__board">
        <TiltTint drag={drag} />
        {deck[1] && !currentCard?.followup && <div className="card card--peek" />}
        <Card
          key={currentCard?.id}
          card={currentCard}
          drag={drag}
          aesthetic={aesthetic}
          onPointerDown={onPointerDown}
        />
        {exitDetail && <ExitCard key={`exit-${exitDetail.card.id}`} detail={exitDetail} />}
      </div>
      {currentCard && (
        <div className="choices">
          <button
            type="button"
            className={'choices__btn choices__btn--left' + (drag.x < -30 ? ' is-tilt' : '')}
            onClick={() => !exiting && onChoice('left')}
          >
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none"
                 stroke="currentColor" strokeWidth="2.4"
                 strokeLinecap="round" strokeLinejoin="round">
              <path d="M19 12H5M11 6l-6 6 6 6" />
            </svg>
            <span>{leftLabel}</span>
          </button>
          <button
            type="button"
            className={'choices__btn choices__btn--right' + (drag.x > 30 ? ' is-tilt' : '')}
            onClick={() => !exiting && onChoice('right')}
          >
            <span>{rightLabel}</span>
            <svg viewBox="0 0 24 24" width="14" height="14" fill="none"
                 stroke="currentColor" strokeWidth="2.4"
                 strokeLinecap="round" strokeLinejoin="round">
              <path d="M5 12h14M13 6l6 6-6 6" />
            </svg>
          </button>
        </div>
      )}
      <div className="play__bottom">
        <DayMeter day={day} style={dayStyle} accent={accent} />
        <div className="play__hint">{t.ui.playHint}</div>
      </div>
    </div>
  );
}
